import Pirsch from "./js/utils/Pirsch";
// Pro singlePage / pro embed = window.maglrSettings?.analytics
// Template embed = window.analyticsSettings
// New name for all frontend analytics stuff = window.maglrAnalyticsSettings
window.maglr_pirsch = new Pirsch(
    window.maglrAnalyticsSettings ?? window.maglrSettings?.analytics ?? window.analyticsSettings,
);
window.maglr_pirsch.interceptor().sendEventUpdate({ hitType: "page_view" });
